function packageSlider() {
  if ($('.js-package-slider').length) {
    const slideToShow = $('.js-package-slider .box-packages__item').length > 3 ? 3 : $('.js-package-slider .box-packages__item').length;
    $('.js-package-slider').slick({
      autoplay: false,
      slidesToShow: slideToShow,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: false,
      draggable: true,
      responsive: [{
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: true,
          infinite: true,
        }
      }]
    });
  }
}

export default packageSlider;
